/* istanbul ignore file */

import { KHFileInfo } from '../../../models';

export class UserGuideLogicServiceModel {
    adminGuide: KHFileInfo;
    logicBuilderGuide: KHFileInfo;
    smartsGuide: KHFileInfo;
    smartsReleaseNotes: KHFileInfo;
    dashboardGuide: KHFileInfo;

    adminGuideLastUpdateDate: Date;
    logicBuilderGuideLastUpdateDate: Date;
    smartsGuideLastUpdateDate: Date;
    smartsReleaseNotesLastUpdateDate: Date;
    dashboardGuideLastUpdateDate: Date;

    isAdminGuideLoading: boolean;
    isLogicBuilderGuideLoading: boolean;
    isSmartsGuideLoading: boolean;
    isSmartsReleaseNotesLoading: boolean;
    isDashboardGuideLoading: boolean;
}
